import { setPendingSelectorResponse } from '@backrs_ui/grow-ui/src/redux/coachLubav/coachLubav';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  createSessionAction,
  getActiveLubavSession,
  getSessionState,
} from '@backrs_ui/grow-ui/src/redux/lubavSessionState/lubavSessionState.utils';
import { type CustomTabId } from '@backrs_ui/grow-ui/src/redux/tabs/customTabIds';
import { closeCustomTab } from '@backrs_ui/grow-ui/src/redux/tabs/tabs.slice';

type SelectorSubmit = Readonly<{
  required: boolean;
  submit: (value: string) => void;
}>;

export const useSelectorSubmit = (tabId: CustomTabId): SelectorSubmit => {
  const dispatch = useAppDispatch();
  const activeSession = useAppSelector(getActiveLubavSession);
  // Assumes the panel mounted in response to the most recent message; defaults to required unless that message opted out.
  const required = useAppSelector((state) => {
    if (!activeSession) return true;

    const messages = getSessionState(state, activeSession).coachLubav.officeHoursMessages;
    const component = messages[messages.length - 1]?.componentType;

    return !component || !('required' in component) || component.required !== false;
  });

  const submit = (value: string) => {
    if (!activeSession) {
      console.error(`useSelectorSubmit(${tabId}): submit with no active session — dropping`);

      return;
    }

    dispatch(createSessionAction(setPendingSelectorResponse, activeSession)(value));
    dispatch(closeCustomTab(tabId));
  };

  return { required, submit };
};
